"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryCache = void 0;
const immutable_1 = __importDefault(require("immutable"));
const SEPARATOR = '|';
class MemoryCache {
    constructor(namespace) {
        this._state = immutable_1.default.Map({
            map: immutable_1.default.OrderedMap(),
        });
        this.setNamespace(namespace);
    }
    setNamespace(namespace) {
        if (namespace.includes(SEPARATOR)) {
            throw new Error(`Namespace cannot contain the "${SEPARATOR}" character.`);
        }
        this.namespace = namespace;
    }
    async get(key) {
        const data = this._state.getIn([
            'map',
            this.getKey(key),
        ]);
        if (!data) {
            return null;
        }
        const { value, expiration } = data;
        if (new Date(expiration) <= new Date()) {
            await this.flush(key);
            return null;
        }
        return value;
    }
    async set(key, data, cacheTTLMs = 20000) {
        const dataPersistable = this.createPersistable(data, cacheTTLMs);
        this._state = this._state.update('map', (map) => map.set(this.getKey(key), dataPersistable));
    }
    async flush(key) {
        this._state = this._state.removeIn(['map', this.getKey(key)]);
    }
    getKey(key) {
        return this.namespace ? `${this.namespace}${SEPARATOR}${key}` : key;
    }
    createPersistable(data, cacheTTLMs) {
        const expiration = new Date().getTime() + cacheTTLMs;
        return { value: data, expiration };
    }
}
exports.MemoryCache = MemoryCache;
